// extracted by mini-css-extract-plugin
export default {"loader":"icon_loader__2aEX-","questionmark":"icon_questionmark__0VFzm","icon":"icon_icon__4mC1O"};